import { DEFAULT_LANGUAGE, DEFAULT_TRANSLATION_MARKET } from "shared/constants";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { SESSION_STORAGE_KEYS } from "shared/sessionStorageUtils";

export const getLanguageAndCountry = () => {
  const { getValueFromLocalStorage } = useLocalStorage();
  
  const language = getValueFromLocalStorage(SESSION_STORAGE_KEYS.language);
  const country = getValueFromLocalStorage(SESSION_STORAGE_KEYS.country);

  const languageCode = language?.value || DEFAULT_LANGUAGE;
  const countryCode = country?.code || DEFAULT_TRANSLATION_MARKET;

  return { languageCode, countryCode };
};
